import React, { FC, useCallback } from 'react'
import { TableFormList } from 'modules/Labels/components'

import { TagFormProps } from './TagForm.props'

const TagsForm: FC<TagFormProps> = ({ tags, onCreateTag, onUpdateTag, maxOrder, setShowAlert }) => {
  const onChangeTag = useCallback(
    (value) => {
      if (value.id) {
        return onUpdateTag({
          id: value.id,
          order_number: value.order_number,
          label: value.label
        })
      } else {
        return onCreateTag({ label: value.label, order_number: maxOrder + 1, label_id: '' })
      }
    },
    [onUpdateTag, onCreateTag, maxOrder]
  )

  return (
    <TableFormList
      entity="Tag"
      fieldName="label"
      isTableHidden
      defaultList={tags}
      onHandleChangeForm={onChangeTag}
      setShowAlert={setShowAlert}
    />
  )
}

export default TagsForm
